<template>
  <div class="menu">
    <h1 class="ma0 app-title" :class="{ animate: titleAnimate }" v-if="appTitle">
      <span v-for="(char, index) in appTitle" :key="`char-${index}`">{{ char }}</span>
    </h1>

    <div class="mt4 mb5">
      <b-field label="Your name">
        <b-input v-model="username"/>
      </b-field>
    </div>

    <m-tile-container>
      <m-tile title="Offline" @click.native="$router.push('/offline')"></m-tile>
      <m-tile title="Online" @click.native="$router.push('/online')"></m-tile>
    </m-tile-container>

    <div class="copyright">
      made by
      <a class="name" target="_blank" href="https://dev.distinctshapes.com/">ex0</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appTitle: 'Memuery',
      titleAnimate: false,
    };
  },

  computed: {
    username: {
      get() {
        return this.$store.state.user.name;
      },
      set(name) {
        return this.$store.commit('setUsername', name);
      },
    },
  },

  mounted() {
    this.titleAnimate = true;
  },
};
</script>

<style lang="scss" scoped>
.menu {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.copyright {
  opacity: 0.5;
  margin-top: 80px;
  font-size: 25px;
  font-weight: 300;
  font-family: rift, sans-serif;

  .name {
    color: $blue;
    font-weight: 800;
  }
}

.app-title {
  transform-style: preserve-3d;
  @include fontHeading;
  font-size: 80px;
  color: $primary;

  span {
    // backface-visibility: hidden;
    display: inline-block;
    transform: rotateX(180deg) scale(0.5);
    opacity: 0;

    @for $i from 1 through 10 {
      &:nth-child(#{$i}) {
        animation-delay: #{$i * 50}ms !important;
      }
    }
  }

  &.animate {
    span {
      animation: flip 1000ms forwards;
    }
  }
}

@keyframes flip {
  0% {
    transform: rotateX(180deg) scale(0.5);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg) scale(1);
    opacity: 1;
  }
}
</style>
